<ui-kit-spinner spinnerIds='selectBin' class="mt-32 mb-32" fxFlexAlign="center"/>
@if (!Spinner.isShown('selectBin')) {
    <div class="org-selector"
         ngClass.desktop="pt-48 pb-48 pl-56 pr-56 shadow-content"
         ngClass.mobile="p-24 w-100"
         fxLayout="column"
         fxFlexAlign="center"
         fxLayoutAlign="start center">
        @if (error) {
            <auth-error class="mt-16" [error]="error" (close)="onClose()" fxFlexAlign="center"/>
        }
        @if (!error) {
            <div fxLayout="column">
                <div class="h2-semi-bold">
                    {{ 'i18n_auth_selectOrganizationTitle' | translate: {orgCount: organizations.length} }}
                </div>
                <div class="t2 mt-20 c-primary-gray-600">
                    {{ 'i18n_auth_selectOrganizationSubtitle' | translate }}
                </div>
                @for (org of organizations; track org; let index = $index) {
                    <div #orgCards
                         (click)="navigateToAuthorize(org.bin)"
                         (keydown.enter)="navigateToAuthorize(org.bin)"
                         [tabindex]="index+1"
                         class="org-card mt-16" ngClass.mobile="w-100">
                        {{ org.name }}
                        <ui-kit-svg name="ic_arrow_right" class="i-24"/>
                    </div>
                }
            </div>
        }
    </div>
}
